import { ringbaUserService } from '@/angularBridgeCode/ringbaPortal.servicesModule';
import {
  DETECT_USER_AGENTS,
  LOCATE_IPS
} from './mutationTypes';

import { SET_ACTION_STATUS_PENDING, SET_ACTION_STATUS_SUCCESS, SET_ACTION_STATUS_ERROR} from '@/store/helpers';

const actions = {
  async locateIps({ rootState, commit }) {
    commit(SET_ACTION_STATUS_PENDING, { actionName: 'locateIps' });
    let ipsResponse = undefined;
    try {
      ipsResponse = (await ringbaUserService.geoLocateIps(rootState.loginSecurity.uniqueIps)).data;
      commit(LOCATE_IPS, ipsResponse);
      commit(SET_ACTION_STATUS_SUCCESS, { actionName: 'locateIps' });
    } catch (e) {
      ipsResponse = rootState.loginSecurity.uniqueIps.map(() => null);
      commit(LOCATE_IPS, ipsResponse);
      commit(SET_ACTION_STATUS_ERROR, { actionName: 'locateIps', error: e });
    }
  },
  async getMyLoginHistory({ dispatch, commit }) {
    commit(SET_ACTION_STATUS_PENDING, { actionName: 'getMyLoginHistory' });
    try {
      const response = await ringbaUserService.getLoginHistory();
      let entries = { ...response.data.loginHistory };

      commit(DETECT_USER_AGENTS, entries);

      await dispatch('locateIps');

      commit(SET_ACTION_STATUS_SUCCESS, { actionName: 'getMyLoginHistory' });
    } catch (e) {
      commit(SET_ACTION_STATUS_ERROR, { actionName: 'locateIps', error: e });
    }
  },
  async revokeAllTokens({ commit }) {
    commit(SET_ACTION_STATUS_PENDING, { actionName: 'revokeAllTokens' });
    try {
      await ringbaUserService.revokeAllTokens();
      commit(SET_ACTION_STATUS_SUCCESS, { actionName: 'revokeAllTokens' });
    } catch (e) {
      commit(SET_ACTION_STATUS_ERROR, { actionName: 'revokeAllTokens', error: e });
    }
  },
};

export default actions;